export default {
  name: 'profile-detail',
  created () {
    Promise.all([
      this.search(),
      this.getCardsWriteCount(),
      this.getCardsGetCount(),
      this.getCardsLikeCount(),
      this.getCardsGetLikeCount()
    ])
  },
  data () {
    return {
      callbackflg: false,
      cardWriteCount: null,
      cardWriteCountTotal: null,
      cardGetCount: null,
      cardGetCountTotal: null,
      likeCount: null,
      likeCountTotal: null,
      likeGetCount: null,
      likeGetCountTotal: null
    }
  },
  computed: {
    profile () {
      return this.$store.getters.profileDetail
    },
    isMyself () {
      return this.profile.attributes['asovi-access-token'] === window.localStorage.getItem('access_token')
    },
    profileImagePath () {
      return this.profile.attributes['profile-image-path'] ? this.profile.attributes['profile-image-path'] : ''
    },
    histories () {
      return this.$store.getters.serviceAnswerHistories
    },
    feedback () {
      return this.$store.getters.serviceAnswerFeedback
    },
    loading () {
      return this.$store.getters.apiLoading
    },
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    timeStamp() {
      var d = new Date()
      var year  = d.getFullYear()
      var month = d.getMonth() + 1
      var day   = d.getDate()
      var hour  = (d.getHours() < 10) ? '0' + d.getHours()   : d.getHours()
      var min   = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec   = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year +''+ month +''+ day +''+ hour +''+ min +''+ sec
    }
  },
  filters: {
    formatCount (count) {
      // カンマ区切り
      return String(count).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    }
  },
  methods: {
    search: function() {
      var self = this
      var data = {}
      var callback
      callback = function() {
        self.callbackflg = true
      }
      this.$store.dispatch('PROFILE_DETAIL',  {id: this.$route.params.id, data: data, callback: callback})
      this.$store.dispatch('SERVICE_ANSWER_HISTORY_LIST')
      this.$store.dispatch('SERVICE_ANSWER_FEEDBACK')
    },
    async getCardsWriteCount () {
      let res = await this.$store.dispatch('CARDS_WRITE_COUNT', {id: this.$route.params.id})
      .catch(err => {
        console.log(err)
        return
      })
      this.cardWriteCount = res.cardWriteCount
      this.cardWriteCountTotal = res.cardWriteCountTotal
    },
    async getCardsGetCount () {
      let res = await this.$store.dispatch('CARDS_GET_COUNT', {id: this.$route.params.id})
      .catch(err => {
        console.log(err)
        return
      })
      this.cardGetCount = res.cardGetCount
      this.cardGetCountTotal = res.cardGetCountTotal
    },
    async getCardsLikeCount () {
      let res = await this.$store.dispatch('CARDS_LIKE_COUNT', {id: this.$route.params.id})
      .catch(err => {
        console.log(err)
        return
      })
      this.likeCount = res.likeCount
      this.likeCountTotal = res.likeCountTotal
    },
    async getCardsGetLikeCount () {
      let res = await this.$store.dispatch('CARDS_GET_LIKE_COUNT', {id: this.$route.params.id})
      .catch(err => {
        console.log(err)
        return
      })
      this.likeGetCount = res.likeGetCount
      this.likeGetCountTotal = res.likeGetCountTotal
    },
    goProfileEdit: function(userId) {
      window.sessionStorage.setItem('profile_edit_referrer', this.$router.history.current.path)
      this.$router.push({ path: '/profile/' + userId + '/edit'})
    },
    goBack: function () {
      if (window.sessionStorage.getItem('profile_detail_referrer')) {
        var referrer = window.sessionStorage.getItem('profile_detail_referrer')
        window.sessionStorage.removeItem('profile_detail_referrer')
        this.$router.push({ path: referrer})
      } else {
        this.$router.go(-1)
      }
    },
    content: function (word) {
      return word ? word.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/\r?\n/g, '<br>') : ''
    },
    disp: function(answer_start_date) {
      let data = {
        answer_start_date: answer_start_date
      }
      this.$store.dispatch('SERVICE_ANSWER_FEEDBACK', { data: data })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/profile-detail.js